
      <!--  KEY VALUE LIST  -->

      <ul class="key-value-list" [ngClass]="'style-' + style + ' size-' + size" [class.stacked]="uiResponsiveService.screenIsLT(adjacentAt)">

          <!--  ITEM LOOP  -->

          <li *ngFor="let item of items" class="row middle-sm1" [class.has-icon]="!!item.icon" [class.has-description]="!!item.description">

              <!--  KEY CONTAINER  -->

              <div class="key-container" [ngClass]="keyContainerCssClass">

                  <!--  ICON  -->

                  <i *ngIf="item.icon" class="pri-hl-col" [ngClass]="item.icon"></i>

                  <!--  END ICON  -->

                  <!--  KEY  -->

                  <p class="key">{{ item.key }}</p>

                  <!--  END KEY  -->

                  <!--  DESCRIPTION  -->

                  <p *ngIf="item.description" class="description">{{ item.description }}</p>

                  <!--  END DESCRIPTION  -->

              </div>

              <!--  END KEY CONTAINER  -->

              <!--  VALUE CONTAINER  -->

              <div *ngIf="item.value" class="value-container" [ngClass]="valueContainerCssClass">

                  <!--  BUTTON  -->

                  <a *ngIf="item.value.type === 'button'"
                     class="button"
                     [ngClass]="item.value.theme + '-button'"
                     [uiLoading]="item.value.showWorking && item.value.working"
                     (click)="onButtonClick(item.value)">
                      {{ item.value.text }}
                  </a>

                  <!--  END BUTTON  -->

                  <!--  ANCHOR LINK  -->

                  <p *ngIf="item.value.type === 'anchorLink'" class="link"><a class="pri-hl-col pri-hl-mix-hov-col" [attr.href]="item.value.href" [attr.target]="item.value.target">{{ item.value.text }}</a>
                  </p>

                  <!--  END ANCHOR LINK  -->

                  <!--  LINK BUTTON  -->

                  <p *ngIf="item.value.type === 'linkButton'" class="link"><a class="pri-hl-col pri-hl-mix-hov-col" (click)="onLinkButtonClick(item.value)">{{ item.value.text }}</a></p>

                  <!--  END LINK BUTTON -->

                  <!--  ROUTER LINK -->

                  <p *ngIf="item.value.type === 'routerLink'" class="link"><a class="pri-hl-col pri-hl-mix-hov-col" [routerLink]="item.value.navigateTo">{{ item.value.text }}</a></p>

                  <!--  END ROUTER LINK -->

                  <!--  TEXT  -->

                  <p *ngIf="item.value.type === 'text'" class="text">{{ item.value.text }}</p>

                  <!--  END TEXT  -->

              </div>

              <!--  END VALUE CONTAINER  -->

          </li>

          <!--  END ITEM LOOP  -->

      </ul>

      <!--  END KEY VALUE LIST  -->
    